import { RQAPICall, RQAPICallWithData } from 'store/APIClient';
import { WIDGET_TYPE } from 'business/constants';
import {
    WidgetContent,
    WidgetT,
} from 'routes/Dashboard/components/WidgetsLayout/helpers';
import { widgetPreProcessingBodyCallback } from '../helper/widgetMiddlewares';
import { LayoutT } from 'business/definitions';
import { ChartDataT } from 'routes/Explore/hooks/updateChartThenUpdateVizSettings';
import { CustomChartDataPayload } from 'routes/BudgetModule/components/BudgetProposal/Resource/Analyse/hooks/addToArgumentHooks';

export type ContainerT = 'dashboard' | 'argument';

export type PayloadWidgetT = {
    content?: WidgetContent;
    chart?: ChartDataT | CustomChartDataPayload;
    position?: WidgetT['position'];
    type: WidgetT['type'];
};

export const createWidget = async (
    container: ContainerT,
    layoutId: number,
    widgetPayload: PayloadWidgetT,
): Promise<WidgetT> => {
    const response = await RQAPICallWithData<WidgetT>({
        endpoint: `explore/layouts/${container}/${layoutId}/widgets`,
        method: 'POST',
        body: widgetPayload,
        preProcessingBodyCallback: widgetPreProcessingBodyCallback,
    });
    return response.content.data;
};

export const moveWidgets = async (
    container: ContainerT,
    layoutId: number,
    widgets: Array<{ key: number; position: WidgetT['position'] }>,
    fromSaveButton: boolean = false,
): Promise<WidgetT[]> => {
    const response = await RQAPICallWithData<LayoutT>({
        endpoint: `explore/layouts/${container}/${layoutId}/widgets_positions`,
        method: 'PUT',
        body: { widgets, fromSaveButton },
    });
    return response.content.data.widgets;
};

const editWidgetChartTitle = async (
    widget: WidgetT,
    content: WidgetContent,
): Promise<Pick<WidgetT, 'key'>> => {
    const chartResponse = await RQAPICallWithData<Pick<WidgetT, 'key'>>({
        endpoint: `explore/layouts/charts/${widget.chart?.key}`,
        method: 'PUT',
        body: { title: content.text },
    });
    return chartResponse.content.data;
};

export const editWidget = async (
    container: ContainerT,
    widget: WidgetT,
    content: WidgetContent,
): Promise<WidgetT | Pick<WidgetT, 'key'>> => {
    // FIXME the backend API should probably handle chart title as widget title
    if (widget.type === WIDGET_TYPE.chart) {
        // for now editWidget only allows title edition for charts
        return editWidgetChartTitle(widget, content);
    }
    const response = await RQAPICallWithData<WidgetT>({
        endpoint: `explore/widget/${container}/${widget.key}`,
        method: 'PUT',
        body: { content },
    });
    return response.content.data;
};

export const deleteWidget = async (
    container: ContainerT,
    widgetKey: number,
): Promise<{ message: string }> => {
    const response = await RQAPICall({
        endpoint: `explore/widget/${container}/${widgetKey}`,
        method: 'DELETE',
    });
    return response.content;
};
